import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'showCurrency'
})
export class ShowCurrencyPipe implements PipeTransform {

  transform(value: number): string {
    if (Number.isInteger(value)) {
      return value.toString()
    } else {
      return Number(value.toFixed(2)).toFixed(2);
    }
  }

}
